var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutMicroInScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5763_1979)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5763_1979)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_5763_1979",
    maskUnits: "userSpaceOnUse",
    x: 4.25,
    y: 10.3,
    width: 16,
    height: 15,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4.25,
    y: 10.3,
    width: 16,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.448 18.1944C13.7001 18.5886 12.861 18.8 12 18.8C10.6076 18.8 9.27225 18.2469 8.28769 17.2624C7.30312 16.2778 6.75 14.9424 6.75 13.55V12.05C6.75 11.8511 6.67098 11.6604 6.53033 11.5197C6.38968 11.3791 6.19891 11.3 6 11.3C5.80109 11.3 5.61032 11.3791 5.46967 11.5197C5.32902 11.6604 5.25 11.8511 5.25 12.05V13.55C5.25002 15.2105 5.86196 16.8126 6.96884 18.0503C8.07571 19.288 9.59988 20.0743 11.25 20.259V22.55H8.25C8.05109 22.55 7.86032 22.6291 7.71967 22.7697C7.57902 22.9104 7.5 23.1011 7.5 23.3C7.5 23.499 7.57902 23.6897 7.71967 23.8304C7.86032 23.971 8.05109 24.05 8.25 24.05H15.75C15.9489 24.05 16.1397 23.971 16.2803 23.8304C16.421 23.6897 16.5 23.499 16.5 23.3C16.5 23.1011 16.421 22.9104 16.2803 22.7697C16.1397 22.6291 15.9489 22.55 15.75 22.55H12.75V20.259C13.7319 20.1491 14.6691 19.8262 15.5004 19.3219L14.448 18.1944ZM18.3653 15.7963C18.6178 15.0806 18.75 14.3216 18.75 13.55V12.05C18.75 11.8511 18.671 11.6604 18.5303 11.5197C18.3897 11.3791 18.1989 11.3 18 11.3C17.8011 11.3 17.6103 11.3791 17.4697 11.5197C17.329 11.6604 17.25 11.8511 17.25 12.05V13.55C17.25 13.8734 17.2202 14.1936 17.1621 14.5071L18.3653 15.7963Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.448 18.1944C13.7001 18.5886 12.861 18.8 12 18.8C10.6076 18.8 9.27225 18.2469 8.28769 17.2624C7.30312 16.2778 6.75 14.9424 6.75 13.55V12.05C6.75 11.8511 6.67098 11.6604 6.53033 11.5197C6.38968 11.3791 6.19891 11.3 6 11.3C5.80109 11.3 5.61032 11.3791 5.46967 11.5197C5.32902 11.6604 5.25 11.8511 5.25 12.05V13.55C5.25002 15.2105 5.86196 16.8126 6.96884 18.0503C8.07571 19.288 9.59988 20.0743 11.25 20.259V22.55H8.25C8.05109 22.55 7.86032 22.6291 7.71967 22.7697C7.57902 22.9104 7.5 23.1011 7.5 23.3C7.5 23.499 7.57902 23.6897 7.71967 23.8304C7.86032 23.971 8.05109 24.05 8.25 24.05H15.75C15.9489 24.05 16.1397 23.971 16.2803 23.8304C16.421 23.6897 16.5 23.499 16.5 23.3C16.5 23.1011 16.421 22.9104 16.2803 22.7697C16.1397 22.6291 15.9489 22.55 15.75 22.55H12.75V20.259C13.7319 20.1491 14.6691 19.8262 15.5004 19.3219L14.448 18.1944ZM18.3653 15.7963C18.6178 15.0806 18.75 14.3216 18.75 13.55V12.05C18.75 11.8511 18.671 11.6604 18.5303 11.5197C18.3897 11.3791 18.1989 11.3 18 11.3C17.8011 11.3 17.6103 11.3791 17.4697 11.5197C17.329 11.6604 17.25 11.8511 17.25 12.05V13.55C17.25 13.8734 17.2202 14.1936 17.1621 14.5071L18.3653 15.7963Z",
    fill: "white",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.448 18.1944L15.1791 17.5121L14.6577 16.9534L13.9818 17.3097L14.448 18.1944ZM8.28769 17.2624L8.9948 16.5553L8.9948 16.5553L8.28769 17.2624ZM6.53033 11.5197L7.23744 10.8126L7.23744 10.8126L6.53033 11.5197ZM5.46967 11.5197L4.76256 10.8126L4.76256 10.8126L5.46967 11.5197ZM5.25 13.55H4.25V13.5501L5.25 13.55ZM6.96884 18.0503L7.71423 17.3837L6.96884 18.0503ZM11.25 20.259H12.25V19.3647L11.3612 19.2653L11.25 20.259ZM11.25 22.55V23.55H12.25V22.55H11.25ZM12.75 22.55H11.75V23.55H12.75V22.55ZM12.75 20.259L12.6388 19.2653L11.75 19.3647V20.259H12.75ZM15.5004 19.3219L16.0191 20.1769L17.0708 19.5389L16.2315 18.6396L15.5004 19.3219ZM18.75 13.55L19.75 13.5501V13.55H18.75ZM18.3653 15.7963L17.6343 16.4786L18.7596 17.6843L19.3083 16.129L18.3653 15.7963ZM18.5303 11.5197L19.2374 10.8126V10.8126L18.5303 11.5197ZM17.4697 11.5197L16.7626 10.8126V10.8126L17.4697 11.5197ZM17.1621 14.5071L16.1788 14.3248L16.0869 14.8207L16.431 15.1894L17.1621 14.5071ZM12 19.8C13.025 19.8 14.024 19.5483 14.9143 19.079L13.9818 17.3097C13.3762 17.6289 12.6969 17.8 12 17.8V19.8ZM7.58058 17.9695C8.75268 19.1416 10.3424 19.8 12 19.8V17.8C10.8728 17.8 9.79183 17.3523 8.9948 16.5553L7.58058 17.9695ZM5.75 13.55C5.75 15.2077 6.40848 16.7974 7.58058 17.9695L8.9948 16.5553C8.19777 15.7582 7.75 14.6772 7.75 13.55H5.75ZM5.75 12.05V13.55H7.75V12.05H5.75ZM5.82322 12.2268C5.77634 12.1799 5.75 12.1164 5.75 12.05H7.75C7.75 11.5859 7.56563 11.1408 7.23744 10.8126L5.82322 12.2268ZM6 12.3C5.93369 12.3 5.87011 12.2737 5.82322 12.2268L7.23744 10.8126C6.90925 10.4844 6.46413 10.3 6 10.3V12.3ZM6.17678 12.2268C6.12989 12.2737 6.06631 12.3 6 12.3V10.3C5.53587 10.3 5.09075 10.4844 4.76256 10.8126L6.17678 12.2268ZM6.25 12.05C6.25 12.1164 6.22366 12.1799 6.17678 12.2268L4.76256 10.8126C4.43437 11.1408 4.25 11.5859 4.25 12.05H6.25ZM6.25 13.55V12.05H4.25V13.55H6.25ZM7.71423 17.3837C6.77131 16.3294 6.25002 14.9645 6.25 13.55L4.25 13.5501C4.25003 15.4564 4.95261 17.2959 6.22344 18.7169L7.71423 17.3837ZM11.3612 19.2653C9.95555 19.1079 8.65715 18.438 7.71423 17.3837L6.22344 18.7169C7.49427 20.1379 9.24421 21.0408 11.1388 21.2528L11.3612 19.2653ZM12.25 22.55V20.259H10.25V22.55H12.25ZM8.25 23.55H11.25V21.55H8.25V23.55ZM8.42678 23.4768C8.37989 23.5237 8.3163 23.55 8.25 23.55V21.55C7.78587 21.55 7.34075 21.7344 7.01256 22.0626L8.42678 23.4768ZM8.5 23.3C8.5 23.3664 8.47366 23.4299 8.42678 23.4768L7.01256 22.0626C6.68437 22.3908 6.5 22.8359 6.5 23.3H8.5ZM8.42678 23.1233C8.47366 23.1702 8.5 23.2337 8.5 23.3H6.5C6.5 23.7642 6.68437 24.2093 7.01256 24.5375L8.42678 23.1233ZM8.25 23.05C8.3163 23.05 8.37989 23.0764 8.42678 23.1233L7.01256 24.5375C7.34075 24.8657 7.78587 25.05 8.25 25.05V23.05ZM15.75 23.05H8.25V25.05H15.75V23.05ZM15.5732 23.1233C15.6201 23.0764 15.6837 23.05 15.75 23.05V25.05C16.2141 25.05 16.6592 24.8657 16.9874 24.5375L15.5732 23.1233ZM15.5 23.3C15.5 23.2337 15.5263 23.1702 15.5732 23.1233L16.9874 24.5375C17.3156 24.2093 17.5 23.7642 17.5 23.3H15.5ZM15.5732 23.4768C15.5263 23.4299 15.5 23.3664 15.5 23.3H17.5C17.5 22.8359 17.3156 22.3908 16.9874 22.0626L15.5732 23.4768ZM15.75 23.55C15.6837 23.55 15.6201 23.5237 15.5732 23.4768L16.9874 22.0626C16.6592 21.7344 16.2141 21.55 15.75 21.55V23.55ZM12.75 23.55H15.75V21.55H12.75V23.55ZM11.75 20.259V22.55H13.75V20.259H11.75ZM14.9818 18.467C14.2736 18.8966 13.4752 19.1716 12.6388 19.2653L12.8612 21.2528C13.9886 21.1267 15.0647 20.7559 16.0191 20.1769L14.9818 18.467ZM16.2315 18.6396L15.1791 17.5121L13.717 18.8767L14.7694 20.0043L16.2315 18.6396ZM17.75 13.55C17.75 14.2073 17.6374 14.8539 17.4223 15.4635L19.3083 16.129C19.5983 15.3074 19.75 14.4359 19.75 13.5501L17.75 13.55ZM17.75 12.05V13.55H19.75V12.05H17.75ZM17.8232 12.2268C17.7763 12.1799 17.75 12.1164 17.75 12.05H19.75C19.75 11.5859 19.5656 11.1408 19.2374 10.8126L17.8232 12.2268ZM18 12.3C17.9337 12.3 17.8701 12.2737 17.8232 12.2268L19.2374 10.8126C18.9092 10.4844 18.4641 10.3 18 10.3V12.3ZM18.1768 12.2268C18.1299 12.2737 18.0663 12.3 18 12.3V10.3C17.5359 10.3 17.0908 10.4844 16.7626 10.8126L18.1768 12.2268ZM18.25 12.05C18.25 12.1164 18.2237 12.1799 18.1768 12.2268L16.7626 10.8126C16.4344 11.1408 16.25 11.5859 16.25 12.05H18.25ZM18.25 13.55V12.05H16.25V13.55H18.25ZM18.1453 14.6894C18.2145 14.3161 18.25 13.9349 18.25 13.55H16.25C16.25 13.8118 16.2259 14.0711 16.1788 14.3248L18.1453 14.6894ZM16.431 15.1894L17.6343 16.4786L19.0964 15.114L17.8931 13.8248L16.431 15.1894Z",
    fill: "#242129",
    fillOpacity: 0.27,
    mask: "url(#path-1-outside-1_5763_1979)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5763_1979)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-2_5763_1979",
    maskUnits: "userSpaceOnUse",
    x: 6.25,
    y: 0.550049,
    width: 11,
    height: 18,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 6.25,
    y: 0.550049,
    width: 11,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27807 4.84197L15.75 12.8476V5.30005C15.75 4.30549 15.3549 3.35166 14.6517 2.6484C13.9484 1.94514 12.9946 1.55005 12 1.55005C11.0054 1.55005 10.0516 1.94514 9.34835 2.6484C8.75393 3.24282 8.37968 4.01624 8.27807 4.84197ZM13.371 17.0404L8.25 11.5536V13.55C8.25 14.5446 8.64509 15.4984 9.34835 16.2017C10.0516 16.905 11.0054 17.3 12 17.3C12.4738 17.3 12.9384 17.2104 13.371 17.0404Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27807 4.84197L15.75 12.8476V5.30005C15.75 4.30549 15.3549 3.35166 14.6517 2.6484C13.9484 1.94514 12.9946 1.55005 12 1.55005C11.0054 1.55005 10.0516 1.94514 9.34835 2.6484C8.75393 3.24282 8.37968 4.01624 8.27807 4.84197ZM13.371 17.0404L8.25 11.5536V13.55C8.25 14.5446 8.64509 15.4984 9.34835 16.2017C10.0516 16.905 11.0054 17.3 12 17.3C12.4738 17.3 12.9384 17.2104 13.371 17.0404Z",
    fill: "white",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27807 4.84197L7.28555 4.71984L7.22855 5.18308L7.54701 5.52429L8.27807 4.84197ZM15.75 12.8476L15.0189 13.5299L16.75 15.3846V12.8476H15.75ZM14.6517 2.6484L13.9445 3.35551V3.35551L14.6517 2.6484ZM9.34835 2.6484L10.0555 3.35551L10.0555 3.35551L9.34835 2.6484ZM13.371 17.0404L13.7366 17.9712L15.1057 17.4334L14.1021 16.3581L13.371 17.0404ZM8.25 11.5536L8.98106 10.8713L7.25 9.0166V11.5536H8.25ZM9.34835 16.2017L10.0555 15.4946H10.0555L9.34835 16.2017ZM7.54701 5.52429L15.0189 13.5299L16.4811 12.1653L9.00912 4.15965L7.54701 5.52429ZM14.75 5.30005V12.8476H16.75V5.30005H14.75ZM13.9445 3.35551C14.4603 3.87123 14.75 4.5707 14.75 5.30005H16.75C16.75 4.04027 16.2496 2.83209 15.3588 1.94129L13.9445 3.35551ZM12 2.55005C12.7293 2.55005 13.4288 2.83978 13.9445 3.35551L15.3588 1.94129C14.468 1.05049 13.2598 0.550049 12 0.550049V2.55005ZM10.0555 3.35551C10.5712 2.83978 11.2707 2.55005 12 2.55005V0.550049C10.7402 0.550049 9.53204 1.05049 8.64124 1.94129L10.0555 3.35551ZM9.27058 4.9641C9.34509 4.35857 9.61957 3.79139 10.0555 3.35551L8.64124 1.94129C7.88829 2.69425 7.41426 3.67391 7.28555 4.71984L9.27058 4.9641ZM14.1021 16.3581L8.98106 10.8713L7.51894 12.2359L12.64 17.7228L14.1021 16.3581ZM9.25 13.55V11.5536H7.25V13.55H9.25ZM10.0555 15.4946C9.53973 14.9789 9.25 14.2794 9.25 13.55H7.25C7.25 14.8098 7.75044 16.018 8.64124 16.9088L10.0555 15.4946ZM12 16.3C11.2707 16.3 10.5712 16.0103 10.0555 15.4946L8.64124 16.9088C9.53204 17.7996 10.7402 18.3 12 18.3V16.3ZM13.0054 16.1097C12.6881 16.2343 12.3475 16.3 12 16.3V18.3C12.6002 18.3 13.1887 18.1865 13.7366 17.9712L13.0054 16.1097Z",
    fill: "#242129",
    fillOpacity: 0.27,
    mask: "url(#path-3-outside-2_5763_1979)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5763_1979)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 5.06011,
    y1: 4.83425,
    x2: 19.0342,
    y2: 19.7399,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5763_1979",
    x: 0.25,
    y: 6.30005,
    width: 23.5,
    height: 22.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.164706 0 0 0 0 0.243137 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5763_1979"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5763_1979",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5763_1979",
    x: 3.22852,
    y: -3.44995,
    width: 17.5215,
    height: 25.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.164706 0 0 0 0 0.243137 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5763_1979"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5763_1979",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5763_1979",
    x: 0.310547,
    y: 0.0842285,
    width: 23.4736,
    height: 24.4058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.164706 0 0 0 0 0.243137 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5763_1979"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5763_1979",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5763_1979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.800049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutMicroInScreen);
export default __webpack_public_path__ + "static/media/cut-micro-in-screen.355b113fbfd784204261a17066dd15c0.svg";
export { ForwardRef as ReactComponent };